import AudioToggleButton from '@/shared/components/audioToggle/AudioToggleButton';
import BackButton from '@/shared/components/button/BackButton';

import '@/features/bouncySums/styles/bouncy-sums-header.scss';

import type { MouseEvent } from 'react';

type BouncySumsHeaderProps = {
	audioToggleTooltip: string;
	progress: number;
	onBack: () => void;
	isGameScreen: boolean;
};

const BouncySumsHeader = ({ audioToggleTooltip, isGameScreen, onBack, progress }: BouncySumsHeaderProps) => {
	const handleBackClick = (event: MouseEvent<HTMLButtonElement>) => {
		if (event.detail === 0) {
			onBack();
		}
	};

	return (
		<div className="bouncy-sums-game__header">
			<div className="bouncy-sums-game__actions">
				<div className="bouncy-sums-game__back-action">
					<BackButton onClick={handleBackClick} onPointerDown={onBack} small />
				</div>
				<div className="bouncy-sums-game__audio-action">
					<AudioToggleButton tooltip={audioToggleTooltip} hiddenTooltip small />
				</div>
			</div>
			<div className="bouncy-sums-game__hud" aria-hidden={!isGameScreen}>
				<div
					className="bouncy-sums-game__progress"
					role="progressbar"
					aria-valuemin={0}
					aria-valuemax={100}
					aria-valuenow={Math.round(progress)}
				>
					<div className="bouncy-sums-game__progress-fill" style={{ width: `${progress}%` }} />
				</div>
			</div>
		</div>
	);
};

export default BouncySumsHeader;
